<template>
  <main-template ref="main_template">
    <template v-slot:main>

      <div class="page_top">
        <bread-crumbs
            :navigation-data="navigationData">
        </bread-crumbs>
      </div>

      <div class="page_content" v-show="showPageContent">

        <div class="product">
          <div class="galary">
            <template v-if="main.images?.length > 1">
              <div class="multi">
              <div class="miniatures">
                <div class="miniature" @click="change_photo(index)" :class="[{active: index == active_photo}]" v-for="(miniature, index) in main.images" :key="index">
                  <img @error="error_load_img(main)" :src="miniature.src">
                </div>
              </div>
              <Carousel v-bind="CarouselConfig" @slide-end="slide_end($event)">
                <Slide v-for="slide in main.images" :key="slide">
                  <img @error="error_load_img(main)" :src="slide.src">
                </Slide>
                <template #addons>
                  <Navigation />
                  <Pagination />
                </template>
              </Carousel>
              </div>
            </template>
            <template v-else>
              <img class="one_image" @error="error_load_img(main)" :src="main.image">
            </template>

          </div>

          <div class="product-right">
            <div class="top">
              <h1 class="title" v-html="main.name"></h1>
              <div class="top_actions">
                <div class="left">
                  <div class="reviews" v-if="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path d="M7.5716 1.21186C7.76593 0.888951 8.23407 0.888951 8.4284 1.21186L10.5241 4.69411C10.5939 4.81011 10.7077 4.89285 10.8396 4.9234L14.799 5.8404C15.1662 5.92544 15.3109 6.37067 15.0638 6.65528L12.3996 9.72443C12.3108 9.82668 12.2673 9.96054 12.279 10.0954L12.6304 14.1444C12.663 14.5199 12.2843 14.7951 11.9373 14.648L8.19505 13.0626C8.07038 13.0098 7.92962 13.0098 7.80496 13.0626L4.06273 14.648C3.71571 14.7951 3.33697 14.5199 3.36955 14.1444L3.72095 10.0954C3.73266 9.96054 3.68916 9.82668 3.60041 9.72443L0.936184 6.65528C0.68913 6.37067 0.833795 5.92544 1.20095 5.8404L5.16036 4.9234C5.29226 4.89285 5.40613 4.81011 5.47595 4.69411L7.5716 1.21186Z" fill="#D1D1D1"/>
                    </svg>
                    <span>0</span>
                    <span class="no">Нет отзывов</span>
                  </div>
                  <div class="article">
                    Арт. {{main.article}}
                  </div>
                </div>
                <div class="right">
                  <svg
                       class="fav" :class="[{active: main.in_fav}]"
                       @click="toggleFavorite(main)"
                       xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10.517 17.3416C10.2337 17.4416 9.76699 17.4416 9.48366 17.3416C7.06699 16.5166 1.66699 13.075 1.66699 7.24165C1.66699 4.66665 3.74199 2.58331 6.30033 2.58331C7.81699 2.58331 9.15866 3.31665 10.0003 4.44998C10.842 3.31665 12.192 2.58331 13.7003 2.58331C16.2587 2.58331 18.3337 4.66665 18.3337 7.24165C18.3337 13.075 12.9337 16.5166 10.517 17.3416Z" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <svg v-if="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2 4H13" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M2 10H8" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M12 10L18 10" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M15 7L15 13" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M2 16H13" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>

                  <svg class="share" @click="share()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M13.6997 7.41669C16.6997 7.67502 17.9247 9.21669 17.9247 12.5917V12.7C17.9247 16.425 16.4331 17.9167 12.7081 17.9167H7.28307C3.55807 17.9167 2.06641 16.425 2.06641 12.7V12.5917C2.06641 9.24169 3.27474 7.70002 6.22474 7.42502" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 12.5V3.01666" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.7913 4.87498L9.99967 2.08331L7.20801 4.87498" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>

            <div class="main">
              <div class="left">
                <div class="characteristics">
                  <span class="title">Характеристики</span>
                  <div class="list">
                    <div class="item" v-for="(prop, index) in props_short" :key="index">
                      <span class="desc">{{prop.name}}</span>
                      <span> — </span>
                      <span class="value">{{prop.value}}</span>
                    </div>
                  </div>
                  <span @click="showMore('characteristics')" class="all">Все характеристики</span>
                </div>
                <div class="description">
                  <span class="text" v-html="main.description"></span>
                  <span @click="showMore('description')" class="all">Все описание</span>
                </div>
              </div>
              <div class="right">
                <div class="actions">
                  <p class="price">{{main.price}}</p>
                  <p class="bonus type">Ваши бонусы</p>
                  <p class="bonus value">{{main.bonuses}}</p>
                  <div class="buttons">
                    <div class="add_to_basket">
                      <template v-if="main.in_basket_quantity > 0">
                        <div class="quantity-controller">
                          <span @click="minusBasket(main)" class="counter__action counter__action--minus"></span>
                          <input class="quantity_value" type="number" @input="setBasket($event.target.value, main)" :value="main.in_basket_quantity">
                          <span @click="plusBasket(main)" class="counter__action counter__action--plus"></span>
                        </div>
                      </template>
                      <template v-if="main.in_basket_quantity <= 0">
                        <div class="add" @click="addToBasket(main)">В корзину</div>
                      </template>
                    </div>
                    <button v-if="false" class="buy">Купить</button>
                  </div>
                </div>
                <div class="availability">
                  <svg v-show="stores.avail_stores > 0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_60_1669)">
                      <path d="M6.6665 9.99999L8.77874 11.901C9.13832 12.2246 9.697 12.1751 9.994 11.7932L13.3332 7.49999M9.99984 18.3333C14.6022 18.3333 18.3332 14.6024 18.3332 9.99999C18.3332 5.39762 14.6022 1.66666 9.99984 1.66666C5.39747 1.66666 1.6665 5.39762 1.6665 9.99999C1.6665 14.6024 5.39747 18.3333 9.99984 18.3333Z" stroke="#69BE15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_60_1669">
                        <rect width="20" height="20" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span>
                    {{stores.avail_text_before}}
                    <span class="stores"
                      @click="function(){
                        $refs.stores_popup.storesData = stores
                        $refs.stores_popup.active = true
                      }">
                      {{stores.avail_text}}
                    </span>
                  </span>
                </div>
                <div class="info">
                  <span class="price">
                    Цена действительна только для интернет-магазина и может отличаться от цен в розничных магазинах
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>





        <div class="tabs">
          <div class="tab_selector">
            <div class="item"
                 :class="[{active : activeTab == 'description'}]"
                 @click="function() {activeTab = 'description'}">Описание</div>
            <div class="item"
                 :class="[{active : activeTab == 'reviews'}]"
                 @click="function() {activeTab = 'reviews'}">Отзывы</div>
            <div class="item"
                 :class="[{active : activeTab == 'characteristics'}]"
                 @click="function() {activeTab = 'characteristics'}">Характеристики</div>
            <div class="item"
                 :class="[{active : activeTab == 'payment'}]"
                 @click="function() {activeTab = 'payment'}">Оплата</div>
            <div class="item"
                 :class="[{active : activeTab == 'delivery'}]"
                 @click="function() {activeTab = 'delivery'}">Доставка</div>
            <div class="item"
                 :class="[{active : activeTab == 'documents'}]"
                 @click="function() {activeTab = 'documents'}">Документы</div>
            <div class="item"
                 :class="[{active : activeTab == 'analogs'}]"
                 @click="function() {activeTab = 'analogs'}">Аналоги</div>
            <div class="item"
                 :class="[{active : activeTab == 'set'}]"
                 @click="function() {activeTab = 'set'}">Комплектующие</div>
          </div>
          <div class="tabs_sep"></div>
          <div id="tab-content" class="tab_content">
            <div v-if="activeTab == 'description'" v-html="main.description"></div>
            <div v-if="activeTab == 'reviews'">

            </div>
            <div v-if="activeTab == 'characteristics'">
              <div class="characteristics_grid">
                <div class="item" v-for="(prop, index) in props" :key="index">
                  <span class="desc">{{prop.name}}</span>
                  <span class="value">{{prop.value}}</span>
                </div>
              </div>
            </div>
            <div v-if="activeTab == 'payment'">

            </div>
            <div v-if="activeTab == 'delivery'">

            </div>
            <div v-if="activeTab == 'documents'">

            </div>
            <div v-if="activeTab == 'analogs'">
              <table-product v-if="analogs?.list?.length > 0" :products-data="analogs" @basket_changed="basket_changed_handler()"></table-product>
            </div>
            <div v-if="activeTab == 'set'">
              <table-product v-if="set?.list?.length > 0" :products-data="set" @basket_changed="basket_changed_handler()"></table-product>
            </div>
          </div>
        </div>

      </div>

      <stores-popup ref="stores_popup"></stores-popup>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BreadCrumbs from "@/components/share/BreadCrumbs";
import StoresPopup from "@/components/catalog/detail/StoresPopup";
import axios from "axios";
import TableProduct from "@/components/catalog/section/TableProduct";

import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

export default {
  name: 'CatalogProductView',
  components: {
    TableProduct,
    StoresPopup,
    BreadCrumbs,
    MainTemplate,

    Carousel, Slide, Pagination, Navigation,
  },
  data() {
    return{
      activeTab : "description",
      tabsData : {
        "description" : "",
        "reviews" : "Отзывы",
        "characteristics" : "Характеристики",
        "payment" : "Оплата",
        "delivery" : "Доставка",
        "documents" : "Документы",
        "analogs" : "Аналоги",
        "set" : "Комплектующие"
      },

      navigationData : [],
      main : {},
      props_short : {},
      props : {},
      stores : {},
      empty_image : require('@/assets/catalog/product/empty.svg'),

      analogs: [],

      set: [],

      CarouselConfig : {
        itemsToShow: 1
      },

      active_photo : 0,

      showPageContent: false
    }
  },
  mounted() {
    this.loadData(this.$route.params.product);
  },
  methods : {
    error_load_img: async function(product) {
      product.image = this.empty_image;
    },
    loadData : async function(product_id) {
      let res = await axios.get(window.api_url + "catalog/detail?id=" + product_id);

      this.navigationData = res.data.data.navigation;

      this.main = res.data.data.main;
      if(this.main.image == null) this.main.image = this.empty_image;

      this.props_short = res.data.data.props_short;
      this.props = res.data.data.props;
      this.stores = res.data.data.stores;

      this.analogs = res.data.data.analogs;

      this.set = res.data.data.set;

      this.showPageContent = true;
    },
    toggleFavorite : async function(product) {
      if(!product.in_fav) {
        let res = await axios.get(window.api_url + "favorite/add?id="+product.id);
        console.log(res);
        product.in_fav = true;
      }
      else {
        let res = await axios.get(window.api_url + "favorite/remove?id="+product.id);
        console.log(res);
        product.in_fav = false;
      }
    },
    addToBasket : async function(product) {
      let qnt = product.in_basket_quantity + 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$refs.main_template.refreshHeader();
    },
    plusBasket : async function(product) {
      let qnt = product.in_basket_quantity + 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$refs.main_template.refreshHeader();
    },
    setBasket: async function(qnt, product) {
      if(!(parseInt(qnt) >= 0)) {return;}

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$refs.main_template.refreshHeader();
    },
    minusBasket : async function(product) {
      if(product.in_basket_quantity <= 0) {return;}
      let qnt = product.in_basket_quantity - 1;

      let res = await axios.get(window.api_url + "basket/set?id="+product.id+"&quantity="+qnt);
      product.in_basket_quantity = res.data.data;

      this.$refs.main_template.refreshHeader();
    },
    showMore : async function (tabName) {
      this.activeTab = tabName;

      await new Promise(r => setTimeout(r, 100));

      document.getElementById("tab-content").scrollIntoView({behavior: "smooth" });
    },
    share() {
      let productLink = window.location.origin + this.$route.path;

      navigator.share({
        title: this.main.name, url: productLink
      });

      console.log(productLink);
    },
    basket_changed_handler : function() {
      this.$refs.main_template.refreshHeader();
    },
    change_photo : function(index) {
      this.active_photo = index;
      index++;
      document.querySelector(".galary .carousel [aria-label='Navigate to slide "+index+"']").click();
    },
    slide_end : function(event) {
      this.active_photo = event.currentSlideIndex;
    }
  },
  watch: {
    '$route.query'() {
      this.loadData(this.$route.params.product)
      this.activeTab = "description";
    }
  }
}
</script>

<style scoped>

.product {
  display: flex;
  gap: 40px;
  margin-bottom: 60px;
}

.product-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.product-right .top {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.product-right .title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  margin: 0px;
}

.product-right .top_actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-right .top_actions .left{
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.product-right .top_actions .left .reviews{
  display: flex;
}

.product-right .top_actions .left .reviews svg{
  padding-right: 4px;
}

.product-right .top_actions .left .reviews span{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.product-right .top_actions .left .reviews span.no{
  border-bottom: 1px dotted #000;
  margin-left: 12px;
  padding-bottom: 2px;
}

.product-right .top_actions .left .article {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  opacity: 0.8;
}

.product-right .top_actions .right{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.product-right .top_actions .right svg{
  cursor: pointer;
}

.product-right .top_actions svg.fav.active path{
  fill: var(--Blue);
  stroke: var(--Blue);
}

.product-right .main {
  display: flex;
  gap: 30px;
}

.product-right .main .left{
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.product-right .main .left .characteristics{
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.product-right .main .left .characteristics .title{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
}

.product-right .main .left .all{
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  text-decoration-line: underline;
  cursor: pointer;
}

.product-right .main .left .characteristics .list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-right .main .left .characteristics .list .item {

}

.product-right .main .left .characteristics .list .item .desc{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.product-right .main .left .characteristics .list .item .value{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.product-right .main .left .description{
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.product-right .main .left .description .text{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;

  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-right .main .right{
  flex: 1;
}

.product-right .main .right .actions {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.04);
  padding: 24px 24px 30px 24px;
  margin-bottom: 10px;
}

.product-right .main .right .actions p {
  margin: 0px;
}

.product-right .main .right .actions .price {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-bottom: 12px;
}

.product-right .main .right .actions .bonus.type {
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 126%;
  margin-bottom: 7px;
}

.product-right .main .right .actions .bonus.value {
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 122%;
  margin-bottom: 20px;
}

.product-right .main .right .actions .buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.product-right .main .right .actions .buttons .add_to_basket {
  border-radius: 8px;
  background: var(--Blue, #1B78BC);
  color: var(--White, #FFF);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 127%;
  outline: none;
  border: none;
  height: 48px;
  cursor: pointer;
}

.product-right .main .right .actions .buttons .add_to_basket .add {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-right .main .right .actions .buttons .add_to_basket .quantity-controller {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 8px;
}

.product-right .main .right .actions .buttons .add_to_basket .quantity-controller input {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  font-size: 16px;
  box-sizing: border-box;
  text-align: center;
  background: transparent;
  color: #fff;
  width: 80px;
}

.counter__action {
  position: relative;
  display: flex;
  height: 100%;
  width: 50px;
}

.counter__action:before {
  width: 12px;
  height: 2px;
  margin-top: -1px;
  margin-left: -6px;
}

.counter__action:after, .counter__action:before {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  border-radius: 1px;
  top: 50%;
  left: 50%;
}

.counter__action--plus:after {
  width: 2px;
  height: 12px;
  margin-top: -6px;
  margin-left: -1px;
}

.product-right .main .right .actions .buttons .buy {
  border-radius: 8px;
  background: rgba(27, 120, 188, 0.10);
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 127%;
  outline: none;
  border: none;
  height: 48px;
  cursor: pointer;
}

.product-right .main .right .availability{
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.06);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.product-right .main .right .availability span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.product-right .main .right .availability .stores {
  cursor: pointer;
  border-bottom: 1px solid var(--Gray, #656565);;
}

.product-right .main .right .info {
  
}

.product-right .main .right .info .price {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%
}

.tabs {

}

.tab_selector {
  display: flex;
  gap: 40px;
}

.tabs_sep {
  height: 1px;
  width: 100%;
  background: #DFDFDF;
  margin-bottom: 30px;
}

.tab_selector .item{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 14px;
  cursor: pointer;
}

.tab_selector .item.active {
  color: #1B78BC;
  border-bottom: 2px solid #1B78BC;
}

.tab_content {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.tab_content .characteristics_grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 4px;
}

.tab_content .characteristics_grid .item {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid var(--Border);
  background: var(--White);
  border-radius: 4px;
}

.tab_content .characteristics_grid .item:hover {
  background: var(--BG);
}

.tab_content .characteristics_grid .item .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.tab_content .characteristics_grid .item .value {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .product {
    flex-direction: column;
    gap: 0px;
  }

  .galary img {
    width: 100%;
    max-width: 365px;
  }

  .product-right {
    gap: 20px;
  }

  .product-right .top_actions {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 12px;
  }

  .product-right .main {
    flex-direction: column;
  }

  .product-right .main .right .actions {
    background: transparent;
    box-shadow: unset;
    padding: 0px;
    margin-bottom: 20px;
  }

  .tab_selector {
    overflow: auto;
  }
}
</style>

<style>

.galary {

}

.galary .one_image {
  width: 356px;
  height: 356px;
  border-radius: 8px;
  background: #fff;
}

.galary .multi {
  display: flex;
  gap: 16px;
}

.miniatures {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.miniature {
  cursor: pointer;
  width: 60px;
  height: 60px;
  background: #fff;
  box-sizing: border-box;
  padding: 2px;

  border: 1px solid transparent;
  border-radius: 8px;
}

.miniature.active {
  border: 1px solid var(--Blue, #1B78BC);
  border-radius: 8px;
}

.miniature img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  object-fit: contain;
}

.galary .carousel {
  width: 356px;
  height: 356px;
  border-radius: 8px;
  background: #fff;
  margin-top: 0px;
}

.galary .carousel .carousel__viewport {
  margin-top: -16px;
}

.galary .carousel img {
  width: 356px;
  height: 356px;
  border-radius: 8px;
  background: #fff;
}

.product .galary .carousel__prev {
  left: 5px;
  right: unset;
  top: 193px;
}

.product .galary .carousel__next {
  left: unset;
  right: 5px;
  top: 193px;
}

.product .galary .carousel__pagination {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .galary .multi {
    flex-direction: column-reverse;
  }
  .miniatures {
    flex-direction: row;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .galary .carousel {
    width: 100%;
    max-width: 356px;
  }

  .galary .carousel img {
    width: 100%;
    max-width: 356px;
  }
}
</style>
